import {createReducer} from '@reduxjs/toolkit';
import {startSync, getSyncStatus} from './actions';

const initialState = {
    status: false
};

export const synchronizer = createReducer(initialState, (builder) =>
    builder
        .addCase(startSync.fulfilled, (state, action) => ({
            status: action.payload
        }))
        .addCase(getSyncStatus.fulfilled, (state, action) => ({
            status: action.payload
        }))
);
